import { render, staticRenderFns } from "./DevicePhoneList.vue?vue&type=template&id=0bb2f489&scoped=true"
import script from "./DevicePhoneList.vue?vue&type=script&lang=js"
export * from "./DevicePhoneList.vue?vue&type=script&lang=js"
import style0 from "./DevicePhoneList.vue?vue&type=style&index=0&id=0bb2f489&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb2f489",
  null
  
)

export default component.exports